import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const regionsSlice = createCrudSlice({
  name: 'regions',
  reducers: {
    watchRegionsRequest: (state) => {
      return {...state, fetching: true};
    },
    unwatchRegionsRequest: (state) => {
      return {...state, fetching: false};
    },   
  },
})

export const RegionsActions = regionsSlice.actions

export const RegionsSelectors = { 
    ...createCrudSelectors({ name: 'regions' }), 

     // Selector personalizado para obtener el currentRegion
    getCurrent: (state) => state.regions.currentRegion
}

export default regionsSlice.reducer
